import { render, staticRenderFns } from "./trainingPortal.vue?vue&type=template&id=24530383&scoped=true"
import script from "./trainingPortal.vue?vue&type=script&lang=js"
export * from "./trainingPortal.vue?vue&type=script&lang=js"
import style0 from "./trainingPortal.vue?vue&type=style&index=0&id=24530383&prod&lang=css"
import style1 from "./trainingPortal.vue?vue&type=style&index=1&id=24530383&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24530383",
  null
  
)

export default component.exports